import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import theme from "Styles/theme.scss";
import { IconProps } from "./types";

const NewSpinnerIcon = ({ width, colour }: IconProps) => {
  return (
    <FontAwesomeIcon
      icon={faSpinner}
      spin
      color={colour ?? theme.neutral7}
      fontSize={width ?? "16px"}
    />
  );
};

export default NewSpinnerIcon;
